import { hasValidGeolocation } from './has-valid-geolocation.util';

interface RepineoAddress {
  geolocationPoint?: unknown;
  geolocationPointUpdate?: boolean | null;
}

/**
 * A client requires repineo (geographic correction) when its principal address
 * has no usable geolocation — reusing the project-wide `hasValidGeolocation`
 * check (null/undefined/`[0,0]`/non-numeric/short tuples) — OR when the
 * repineo-request flag is explicitly set on the address.
 */
export function requiresRepineo(address: RepineoAddress | undefined | null): boolean {
  if (!address) return true;
  if (address.geolocationPointUpdate === true) return true;
  return !hasValidGeolocation(address.geolocationPoint);
}
